import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { AdminTitle } from "./shared";

export default function LeadsInbox() {
  const [leads, setLeads] = useState(null);

  const load = () => api.get("/admin/leads").then((r) => setLeads(r.data.leads)).catch(() => setLeads([]));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    await api.delete(`/admin/leads/${id}`);
    load();
  };

  if (!leads) return <p className="text-clay">Loading…</p>;

  return (
    <div data-testid="leads-inbox">
      <AdminTitle eyebrow="Inbox" title={`Event Requests (${leads.length})`} />
      {!leads.length && <p className="text-sm text-clay">No requests yet — they'll land here when someone submits the event form.</p>}
      <div className="space-y-4">
        {leads.map((lead) => (
          <div key={lead.id} className="rounded-sm border border-brass/10 bg-card p-6" data-testid={`lead-card-${lead.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="font-serif text-lg text-cream">{lead.name} <span className="ml-2 text-xs font-mono text-brass uppercase tracking-widest">{lead.event_type}</span></p>
                <p className="mt-1 text-xs text-clay">{lead.email} {lead.phone && `· ${lead.phone}`} {lead.event_date && `· ${lead.event_date}`} {lead.guests && `· ${lead.guests} guests`}</p>
              </div>
              <button onClick={() => remove(lead.id)} data-testid={`lead-delete-${lead.id}`} className="text-clay hover:text-flame"><Trash2 size={15} /></button>
            </div>
            <p className="mt-2 text-xs font-mono text-clay/70">{lead.cuisine} · {lead.service_style} · via {lead.referral}</p>
            {lead.message && <p className="mt-3 text-sm text-clay leading-relaxed border-l-2 border-brass/30 pl-4">{lead.message}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
